<template>
    <el-button type="warning" size="mini" v-if="isShow" icon="el-icon-delete" :disabled="disabled">{{label}}</el-button>
</template>

<script>
export default {
    name: "DelButton",
    props: {
        rule: '',
        disabled: {
            type: Boolean,
            default: false
        },
        label:{
            type:String,
            default:'删除'
        }
    },
    computed: {
        isShow() {
            if(this.rule) {
                return this.$rule.checkRule(this.rule);
            }else{
                return true;
            }
        }
    }
}
</script>
